import { createContext, useState } from 'react';

export const TitleContext = createContext();

export const TitleProvider = ({ children }) => {
  const [title, setTitle] = useState('');
  const [titleLoading, setTitleLoading] = useState(false);
  const value = {
    title,
    setTitle,
    titleLoading,
    setTitleLoading,
  };

  return <TitleContext.Provider value={value}>{children}</TitleContext.Provider>;
};
